import { ProblemCategoryDTO } from './../masterdata/models/problemCategory';
import { Component, OnInit, Input } from '@angular/core';
import { LabMDM, SelectableLab } from '../masterdata/models/lab';
import { MessagesService } from '../messages/messages.service';
import { MasterDataService } from '../masterdata/masterdata.service';
import { ErrorHandler } from '../utils/error-handler';
import { SenderDTO } from '../masterdata/models/sender-dto';
import { SelectItem } from 'primeng/api';
import { MachineManufacturerOptionsCycler, MachineManufacturerOptionOther, MachineManufacturerOptionsExtractor } from '../crud-table/machine-options';
import { OperetionHistoryDTO } from '../masterdata/models/operationHistory';

@Component({
  selector: 'app-senders-template',
  templateUrl: './senders-template.component.html',
  styleUrls: ['./senders-template.component.css']
})
export class SendersTemplateComponent implements OnInit {

  @Input() masterLists: SenderDTO[];
  @Input() tableCols: any[];
  @Input() title: string;
  @Input() labOptions: LabMDM[];
  @Input() checkSelectedLab: SelectableLab;
  @Input() loading:boolean;
  
  labOption: LabMDM[]=[];
  isNewMasterList: boolean;
  popupTitle: string;
  masterList: SenderDTO;
  displayMasterListDialog: boolean = false;
  selectedLabName: string;
  selectedLab: LabMDM;
  errorHandler: ErrorHandler = new ErrorHandler;
  selectedMasterList: SenderDTO;
  entityOptions: any[];
  senders: any[];
  isActive: string = "active";
  isLab: string = "lab";
  isSenderName: string = "senderName";
  isSenderShortName: string = "senderShortName";
  isBarcodeFormat: string = "barcodeFormat";
  isTrfBarcode:string = "trfBarcode";
  isTrfFormat:string = "trfFormat";
  isBoxBarcode:string = "boxBarcode";
  isBoxBarcodeFormat:string = "boxBarcodeFormat";
  isExternalSampleBarcode:string = "externalSampleBarcode";
  isExternalSampleFormat:string = "externalSampleFormat";
  isCheckForIdentity:string = "checkForIdentity";
  isMergeGroup:string = "mergeGroup";
  isBarcodeValidationRequired: string = 'barcodeValidationRequired';
  isDataFormat: string = 'dataFormat';
  isContactID:string = 'contactID';
  isSwabType:string = 'swabType';
  isSenderGroupName:string = 'senderGroupName';
  isStorageTime:string = 'storageTime';
  isBarcodeExistOnBag:string = 'barcodeExistOnBag';
  isCategoryType: string ="categoryType"
  isFormat: string = 'format';
  isDefaultPriority: string = 'defaultPriority';
  isAllowedPCRKits: string = 'allowedPCRKits';
  isAllowedExtractorKits: string = 'allowedExtractionKits';
  isAllowedCyclerTypes: string = 'allowedCyclerTypes';
  isAllowedExtractorTypes: string = 'allowedExtractorTypes';
  isRegionalCodes:string = "regionalCodes";
  trfBarcode: any[] = [];
  boxBarcode: any[] = [];
  externalSampleBarcode: any[] = [];
  checkForIdentity: any[] = [];
  dataFormatOptions: any[] = [];
  problemOptions: ProblemCategoryDTO[] = [];
  selectedCategory: ProblemCategoryDTO[] = [];

  deafultPriorityList: SelectItem[] = [];
  allowedPCRKitsList: SelectItem[] = [];
  allowedExtractorKitsList: SelectItem[] = [];
  allowedCyclerManufacturerList: SelectItem[] = [];
  allowedExtractorManufacturerList: SelectItem[] = [];

  selectedLabId: string;
  mapOfKits: any;
  swabTypeList: SelectItem[] = [];
  regionalCode: string;
  blocked: boolean = false;
  puid = localStorage.getItem('PUID');
  constructor(private _messageService: MessagesService, private _masterDataService: MasterDataService) { }

  ngOnInit() {
    this.popupTitle = this.title.slice(0, -1);
    this.selectedLabId = JSON.parse(localStorage.getItem('lab')).lab._id;
    this.entityOptions = [
      { field: 'Tube', label: 'Tube' },
      { field: 'Plate', label: 'Plate' },
      { field: 'Other', label: 'Other' }
    ];

    this.trfBarcode = [
      { value: 'Mandatory Scan', label: 'Mandatory Scan' },
      { value: 'Optional Scan', label: 'Optional Scan' },
      { value: 'Not Used', label: 'Not Used' }
    ];

    this.boxBarcode = [
      { value: 'Mandatory Scan', label: 'Mandatory Scan' },
      { value: 'Optional Scan', label: 'Optional Scan' },
      { value: 'Not Used', label: 'Not Used' }
    ];

    this.externalSampleBarcode = [
      { value: 'Mandatory Scan', label: 'Mandatory Scan' },
      { value: 'Optional Scan', label: 'Optional Scan' },
      { value: 'Not Used', label: 'Not Used' }
    ];

    this.checkForIdentity = [
      { value: 'TRF = Sample', label: 'TRF=Sample' },
      { value: 'TRF = External', label: 'TRF=External' },
      { value: 'None', label: 'None' }
    ];
    this.swabTypeList = [
      { value: 'Dry', label: 'Dry' },
      { value: 'Wet', label: 'Wet' },
      { value: 'Saliva', label: 'Saliva' }
    ];
    this.dataFormatOptions = [
      { value: 'CSV', label: 'CSV' },
      { value: 'Excel', label: 'Excel' },
      { value: 'Excel With MultiChannels', label: 'Excel With MultiChannels' },
      { value: 'Excel(retest)', label: 'Excel (retest)' },
      { value: 'HL7', label: 'HL7' }
    ];

    this.deafultPriorityList = [
      { value: 'Standard', label: 'Standard' },
      { value: 'Rush', label: 'Rush' }
    ];

    this.allowedCyclerManufacturerList = this.getAllowedCyclerManufacturerList();
    this.allowedExtractorManufacturerList = this.getAllowedExtractorManufacturerList();
  }

  convertArrayOfStringToObjectArray(objectToArray: Map<string, Object>, kitType: string) {
    let newArray: any[] = [];
    Object.entries(objectToArray.get(kitType)).forEach(([key, value]) => {
      newArray.push({ label: value, value: value });

    });
    return newArray;
  }

  //Display master Dialog upon clicked on a row
  onRowSelect(event) {
    this.isNewMasterList = false;
    this.masterList = this.cloneMasterList(event.data);
    if(this.masterList.regionalCodes != null){
      this.regionalCode = this.masterList.regionalCodes.join(',');
    }else{
      this.regionalCode= '';
    }
    this.getActiveOptionsForDropdowns();
    this.displayMasterListDialog = true;
  }

  //Retrieve the Active lab for dropdown
  getActiveOptionsForDropdowns() {
    this.labOption=[];
    this._masterDataService.getLabs(true).subscribe(
      results => {
        if (!results) {
          return;
        }

        let checkSelectedLabName = this.checkSelectedLab.lab.name;
        this.labOptions = results.data;
        this.labOptions.forEach(lab => {
          if(lab.name == checkSelectedLabName) {
            this.labOption.push(lab);
          }
          if (this.masterList && this.masterList.lab && lab._id == this.masterList.lab._id) {
            this.selectedLabName = this.masterList.lab.name;
            this.selectedLab = lab;
          }
        });
        this.labOptions = this.labOption;
        if (!this.masterList || !this.masterList.lab || this.selectedLabName != this.masterList.lab.name)
          this.selectedLab = null;
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
        }
    );
 }
  //Display Add Dialog upon clicking Add button
  showDialogToAddMasterList() {
    this.isNewMasterList = true;
    this.masterList = new SenderDTO;
    this.masterList.swabType="Dry"
    this.masterList.defaultPriority = 'Standard';
    this.masterList.allowedPCRKits = [];
    this.masterList.allowedExtractionKits = [];
    this.masterList.allowedCyclerTypes = [];
    this.masterList.allowedExtractorTypes = [];
    this.displayMasterListDialog = true;
    this.getActiveOptionsForDropdowns();
    this.selectedLab = null;
    this.selectedCategory = null;
    this.masterList.storageTime = 5;
    this.regionalCode='';
  }

  cloneMasterList(list: any): any {
    let masterList = {};
    for (let prop in list) {
      masterList[prop] = list[prop];
    }
    return masterList;
  }
  private handleError(error: any) {
    let message = this.errorHandler.handleError(error);
    this._messageService.addErrorMessage(message);
    this.blocked=false
  }
  //Insert or update Template
  saveMasterList() {
    let masterLists = [...this.masterLists];
    if(!this.regionalCode){
      this._messageService.addErrorMessage({ severity: 'error', summary: 'External Sample Batcode Empty!', 
        detail: 'All senders must have External Sample Format (Regional code)' });
      return;
    }
    if (this.isNewMasterList) {
      this.saveMasterData(masterLists);
    }
    else {
      this.updateMasterData(masterLists);
    }
  }

  //Inserts a new Template in DB
  saveMasterData(masterLists: any[]) {
    this.masterList.lab = new LabMDM();
    this.masterList.lab = this.selectedLab;
    this.masterList.categoryType = [];
    if (this.selectedCategory && this.selectedCategory.length > 0) {
    this.selectedCategory.forEach(ele => {
      this.masterList.categoryType.push(ele.categoryName);
    });
    }
    this.masterList.regionalCodes = this.regionalCode.split(',');
    this.blocked=true;
    this.appendHistory("Senders");
    this._masterDataService.addSender(this.masterList).subscribe(
      results => {
        if (!results) {
          return;
        }
        masterLists = [...this.masterLists];
        masterLists.push(results.data);
        this.masterLists = masterLists;
        this.masterList = null;
        this.displayMasterListDialog = false;
        this.blocked=false
      },
      error => {
        this.handleError(error);
        }
    );
  }

  //Updates a Template in DB
  updateMasterData(masterLists: any[]) {
    this.masterList.lab = new LabMDM();
    this.masterList.lab = this.selectedLab;
    this.masterList.categoryType = [];
    if (this.selectedCategory && this.selectedCategory.length > 0) {
    this.selectedCategory.forEach(ele => {
      this.masterList.categoryType.push(ele.categoryName);
    });
    }
    this.masterList.regionalCodes = this.regionalCode.split(',');
    this.blocked=true;
    this.appendHistory("Senders");
     this._masterDataService.updateSender(this.masterList).subscribe(
       results => {
         if (!results) {
           return;
         }
         masterLists[this.masterLists.indexOf(this.selectedMasterList)] = results.data;
         this.masterLists = masterLists;
         this.masterList = null;
         this.displayMasterListDialog = false;
         this.blocked=false
       },
       error => {
        this.handleError(error);
         }
     );
  }

  //Check if the Template Name or Lab is Entered or not, if not disable Save button
  isSaveDisabled() {
    if (this.masterList == undefined || this.masterList == null)
      return true;
    return false;
  }

  getAllowedCyclerManufacturerList() {
    return MachineManufacturerOptionsCycler.concat(MachineManufacturerOptionOther);
  }

  getAllowedExtractorManufacturerList() {
    return MachineManufacturerOptionsExtractor.concat(MachineManufacturerOptionOther);
  }

  appendHistory(tabName: string){
    let historyObj:OperetionHistoryDTO = new OperetionHistoryDTO();
    historyObj.puid = this.puid;
    historyObj.operationDateTime = new Date();
    historyObj.tabName = tabName;
    if(this.masterList.history){
      this.masterList.history.push(historyObj);
    } else {
      this.masterList.history = [];
      this.masterList.history.push(historyObj);
    }
  }
}
